export const DATA_ENDPOINT = `${process.env.DATA_ENDPOINT || "http://localhost:3000"}/api/data`;
